import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Dropdown: ComponentStyleConfig = {
  baseStyle: {
    display: 'inline-flex',
    w: '100%',
  },
  variants: {
    labelLeft: {
      alignItems: 'center',
      flexDirection: 'row',
      label: {
        mb: 0,
      },
    },
    labelTop: {
      flexDirection: 'column',
      label: {
        mr: 0,
      },
    },
    labelFloat: {},
  },
  defaultProps: {
    variant: 'labelLeft',
  },
};

export default Dropdown;
